import { Outlet, useLocation } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { useAuthStore } from '@/stores/auth.store'
import { ZanshinDataProvider } from '@/contexts/ZanshinContext'

// Route che NON devono pollare lo stato Zanshin (es. demo con dati mockati).
// Mantenere allineata con le route che mostrano solo presentazione statica.
const ZANSHIN_POLLING_DISABLED_PATHS = ['/admin/zanshin-demo']

export const Layout = () => {
  const { hasActiveSubscription, isAdmin } = useAuthStore()
  const location = useLocation()
  // Gating: il polling Zanshin parte solo per admin o utenti con subscription
  // attiva, ed e' disabilitato su route che non lo consumano (es. demo).
  const isPollingRoute = !ZANSHIN_POLLING_DISABLED_PATHS.includes(location.pathname)
  const zanshinEnabled = (isAdmin || hasActiveSubscription) && isPollingRoute

  return (
    <ZanshinDataProvider enabled={zanshinEnabled}>
      <div className="flex h-screen bg-background">
        <Sidebar />

        <div className="flex-1 flex flex-col overflow-hidden">
          <Header />

          <main className="flex-1 overflow-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </ZanshinDataProvider>
  )
}
